// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__LCE+d","btn_background_img":"styles_btn_background_img__i67H9"};